import { KfzTypSelectOption } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_COLLISION_PICKER = 'COLLISION_PICKER';

export interface CollisionPickerViewModel {
  selection?: number[];
  getScreenshotFile: () => Promise<File>;
}

export interface CollisionPickerModelConfig extends DynamicFormValueControlModelConfig<CollisionPickerViewModel> {
  kfzTyp?: KfzTypSelectOption;
}

export class CollisionPickerModel extends DynamicFormValueControlModel<CollisionPickerViewModel> {
  @serializable() readonly type: string = TYPE_COLLISION_PICKER;
  @serializable() kfzTyp: KfzTypSelectOption;

  constructor(config: CollisionPickerModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.kfzTyp = config.kfzTyp || null;
  }
}
